(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Aboutus"] && !Shopify.designMode) return;
  try {
    
// Animated Counter for Stats and Mobile Click for Cards
document.addEventListener('DOMContentLoaded', function() {
  const animateNumbers = () => {
    const numbers = document.querySelectorAll('.stat-number');
    
    numbers.forEach(number => {
      const target = parseInt(number.getAttribute('data-target'));
      const increment = target / 50;
      let current = 0;
      
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          number.textContent = target;
          clearInterval(timer);
        } else {
          number.textContent = Math.floor(current);
        }
      }, 50);
    });
  };

  const statsObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateNumbers();
        statsObserver.unobserve(entry.target);
      }
    });
  });

  const statsSection = document.querySelector('.stats-3d');
  if (statsSection) {
    statsObserver.observe(statsSection);
  }

  // Mobile click handler for card flip
  const cards = document.querySelectorAll('.story-card-3d');
  
  cards.forEach(card => {
    card.addEventListener('click', () => {
      // Toggle the 'flipped' class on click
      card.classList.toggle('flipped');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
